import React, { Component } from 'react';
import '../App.css';


class NavBar extends Component {
 render(){
    return (
        <div class="topnav" id="myTopnav">
        <a href="#home" class="active">Home</a>
        <a href="#features">Features</a>
        <a href="#pricing">Pricing</a>
        <a href="#partners">Partners</a>
        <a href="#help">Help</a>
        <i class="fa fa-bars"></i>
      </div>
    );
}
 }   
export default NavBar;